import * as React from 'react';
import { GetStorageComponent } from '../../utils/storage';
import EntranceHeader from '../../components/EntranceHeader';
import AuthInstance from '../../Auth/Auth';

class AuthError extends React.Component<any> {

  signIn = () => {
    AuthInstance.login()
  }

  render() {
    const accessToken = GetStorageComponent('access_token');

    if (accessToken) {
      return (
        <div className="app-bg">
          <EntranceHeader />
          <section role="form-section">
            <div className="auth-error-wrap">
              <div className="auth-error-icon"><img src="images/letter.svg" /></div>
              <h2>Time to Check Your Email</h2>
              <p>Click the link in your email to confirm your account.
              If you can't find the email check your spam folder {/* or click link below to
              re-send email */}.
            </p>
              {/* <button onClick={this.signIn} className="btn btn-md btn-blue">Home Page</button> */}
            </div>
          </section>
        </div>
      );
    } else {
      return (
        <div className="app-bg">
          <EntranceHeader />
          <section role="form-section">
            <div className="auth-error-wrap">
              <div className="auth-error-icon"><img src="images/letter.svg" /></div>
              <h2>Time to Check Your Email</h2>
              <p> Your email has not been confirmed yet. Please confirm your email.</p>
              {/* <button onClick={this.signIn} className="btn btn-md btn-blue">Login</button> */}
            </div>
          </section>
        </div>
      );
    }
  }
}

export default AuthError;
